import { render, staticRenderFns } from "./videodisplay.vue?vue&type=template&id=a00732c4&scoped=true"
import script from "./videodisplay.vue?vue&type=script&lang=js"
export * from "./videodisplay.vue?vue&type=script&lang=js"
import style0 from "./videodisplay.vue?vue&type=style&index=0&id=a00732c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00732c4",
  null
  
)

export default component.exports